import { VALIDATION_TEMPLATE } from './validationTemplete';

export const PROJECT_VALIDATION = {
  FIELDS: [
    'projectNumber',
    'projectName',
    'clientName',
    'startDate',
    'endDate',
  ],
  MESSAGE: {
    projectNumber: {
      required: VALIDATION_TEMPLATE.required('プロジェクトナンバー'),
      pattern: VALIDATION_TEMPLATE.projectNumber(),
    },
    projectName: {
      required: VALIDATION_TEMPLATE.required('プロジェクト名'),
    },
    clientName: {
      required: VALIDATION_TEMPLATE.required('クライアント名'),
    },
    startDate: {
      required: VALIDATION_TEMPLATE.required('開始日'),
    },
    endDate: {
      required: VALIDATION_TEMPLATE.required('終了予定日'),
    },
  },
  RULES: {
    projectNumber: {
      required: true,
      pattern: /^[a-zA-Z0-9]{1,8}$/, // 半角英数字1〜8文字
    },
    projectName: {
      required: true,
    },
    clientName: {
      required: false,
    },
    startDate: {
      required: true,
    },
    endDate: {
      required: true,
    },
  },
};
